/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Profile_Active_TraderInputs */

const en_onboarding_v1_profile_active_trader = /** @type {(inputs: Onboarding_V1_Profile_Active_TraderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I am an active trader.`)
};

const de_onboarding_v1_profile_active_trader = /** @type {(inputs: Onboarding_V1_Profile_Active_TraderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich handle aktiv.`)
};

const pt_br2_onboarding_v1_profile_active_trader = /** @type {(inputs: Onboarding_V1_Profile_Active_TraderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faço operações ativamente.`)
};

const tr_onboarding_v1_profile_active_trader = /** @type {(inputs: Onboarding_V1_Profile_Active_TraderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif işlem yaparım.`)
};

const zh_cn2_onboarding_v1_profile_active_trader = /** @type {(inputs: Onboarding_V1_Profile_Active_TraderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我是活跃交易者。`)
};

const zh_hk2_onboarding_v1_profile_active_trader = /** @type {(inputs: Onboarding_V1_Profile_Active_TraderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我是活躍交易者。`)
};

const ko_kr2_onboarding_v1_profile_active_trader = /** @type {(inputs: Onboarding_V1_Profile_Active_TraderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저는 활발하게 거래합니다.`)
};

const ru_ru2_onboarding_v1_profile_active_trader = /** @type {(inputs: Onboarding_V1_Profile_Active_TraderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я активно торгую.`)
};

const es_419_onboarding_v1_profile_active_trader = /** @type {(inputs: Onboarding_V1_Profile_Active_TraderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hago operaciones activamente.`)
};

/**
* | output |
* | --- |
* | "I am an active trader." |
*
* @param {Onboarding_V1_Profile_Active_TraderInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_profile_active_trader = /** @type {((inputs?: Onboarding_V1_Profile_Active_TraderInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Profile_Active_TraderInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_profile_active_trader(inputs)
	if (locale === "de") return de_onboarding_v1_profile_active_trader(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_profile_active_trader(inputs)
	if (locale === "tr") return tr_onboarding_v1_profile_active_trader(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_profile_active_trader(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_profile_active_trader(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_profile_active_trader(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_profile_active_trader(inputs)
	return es_419_onboarding_v1_profile_active_trader(inputs)
});